import jQuery from 'jquery';

/*
 * This script registers functions to wc_bookings_booking_form global object.
 * These functions return product setting value for specific booking form.
 *
 * @since 1.15.73
 */
jQuery( document ).ready( function ( $ ) {
	/**
	 * Should return whether multiple booking forms exist on webpage.
	 *
	 * @since 1.15.73
	 *
	 * @return {boolean} Whether multiple booking forms exist.
	 */
	wc_bookings_booking_form.is_multiple_booking_forms_exist = () => {
		return !! $( '.wc-bookings-booking-form' ).closest( 'form' ).length;
	};

	/**
	 * Should return booking form product id.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Product ID.
	 */
	wc_bookings_booking_form.get_booking_product_id = ( element ) => {
		let form = element.closest( 'form' );
		form = element instanceof jQuery ? form.get( 0 ) : form;
		return parseInt(
			form.querySelector( '.wc-booking-product-id' ).value,
			10
		);
	};

	/**
	 * Should return booking duration.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Booking duration.
	 */
	wc_bookings_booking_form.get_booking_duration = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.booking_duration;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.booking_duration;
	};

	/**
	 * Should return booking duration type.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Booking duration type.
	 */
	wc_bookings_booking_form.get_booking_duration_type = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.booking_duration_type;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.duration_type;
	};

	/**
	 * Should return booking max duration.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Maximum booking duration.
	 */
	wc_bookings_booking_form.get_booking_max_duration = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.booking_max_duration;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.booking_max_duration;
	};

	/**
	 * Should return booking max duration.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Minimum booking duration.
	 */
	wc_bookings_booking_form.get_booking_min_duration = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.booking_min_duration;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.booking_min_duration;
	};

	/**
	 * Should return booking check availability against.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Availability-check mode.
	 */
	wc_bookings_booking_form.get_booking_check_availability_against = (
		element
	) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.check_availability_against;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.check_availability_against;
	};

	/**
	 * Should return booking default availability.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Default availability.
	 */
	wc_bookings_booking_form.get_booking_default_availability = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.default_availability;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.default_availability;
	};

	/**
	 * Should return booking duration unit.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Booking duration unit.
	 */
	wc_bookings_booking_form.get_booking_duration_unit = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.duration_unit;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.duration_unit;
	};

	/**
	 * Should return booking resources assignment.
	 *
	 * @since 1.15.73
	 *
	 * @param {Object} element
	 * @return {string} Resource assignment mode.
	 */
	wc_bookings_booking_form.get_booking_resources_assignment = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.resources_assignment;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ]
			.resources_assignment;
	};

	/**
	 * Should return booking resources IDs.
	 *
	 * @since 1.16.02
	 *
	 * @param {Object} element
	 * @return {Array} The resource IDs.
	 */
	wc_bookings_booking_form.get_booking_resource_ids = ( element ) => {
		let productId = null;
		if ( ! wc_bookings_booking_form.is_multiple_booking_forms_exist() ) {
			return window.wc_bookings_booking_form.resource_ids;
		}
		productId = wc_bookings_booking_form.get_booking_product_id( element );
		return window[ `wc_bookings_booking_form_${ productId }` ].resource_ids;
	};

	/**
	 * should return sanitized text
	 *
	 * @since 1.15.73
	 *
	 * @param {string} text
	 *
	 * @return {string} Sanitized text.
	 */
	wc_bookings_booking_form.sanitize_text = ( text ) => {
		const element = document.createElement( 'div' );
		element.innerText = text;
		return element.innerHTML;
	};
} );
